import React, { Component } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

import NumberFormat from "react-number-format";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { MuiThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import Autocomplete from "@mui/material/Autocomplete";

import { toISOString } from "../../../../helpers/utils";
import NumberFormatInput from "./numberFormatInput";
import unCheckedRadioIcon from "../../../../../assets/uncheckedRadioIcon.svg";
import checkedBlueIcon from "../../../../../assets/checked-blue-icon.svg";
import calendarIcon from "../../../../../assets/calendarIcon.svg";

import "./styles/index.scss";
import DKFormTextInput from "./DKFormTextInput";

export const states = [
  {
    name: "Alabama",
    abbreviation: "AL",
  },
  {
    name: "Alaska",
    abbreviation: "AK",
  },

  {
    name: "Arizona",
    abbreviation: "AZ",
  },
  {
    name: "Arkansas",
    abbreviation: "AR",
  },
  {
    name: "California",
    abbreviation: "CA",
  },
  {
    name: "Colorado",
    abbreviation: "CO",
  },
  {
    name: "Connecticut",
    abbreviation: "CT",
  },
  {
    name: "Delaware",
    abbreviation: "DE",
  },
  {
    name: "District Of Columbia",
    abbreviation: "DC",
  },
  {
    name: "Florida",
    abbreviation: "FL",
  },
  {
    name: "Georgia",
    abbreviation: "GA",
  },
  {
    name: "Hawaii",
    abbreviation: "HI",
  },
  {
    name: "Idaho",
    abbreviation: "ID",
  },
  {
    name: "Illinois",
    abbreviation: "IL",
  },
  {
    name: "Indiana",
    abbreviation: "IN",
  },
  {
    name: "Iowa",
    abbreviation: "IA",
  },
  {
    name: "Kansas",
    abbreviation: "KS",
  },
  {
    name: "Kentucky",
    abbreviation: "KY",
  },
  {
    name: "Louisiana",
    abbreviation: "LA",
  },
  {
    name: "Maine",
    abbreviation: "ME",
  },
  {
    name: "Maryland",
    abbreviation: "MD",
  },
  {
    name: "Massachusetts",
    abbreviation: "MA",
  },
  {
    name: "Michigan",
    abbreviation: "MI",
  },
  {
    name: "Minnesota",
    abbreviation: "MN",
  },
  {
    name: "Mississippi",
    abbreviation: "MS",
  },
  {
    name: "Missouri",
    abbreviation: "MO",
  },
  {
    name: "Montana",
    abbreviation: "MT",
  },
  {
    name: "Nebraska",
    abbreviation: "NE",
  },
  {
    name: "Nevada",
    abbreviation: "NV",
  },
  {
    name: "New Hampshire",
    abbreviation: "NH",
  },
  {
    name: "New Jersey",
    abbreviation: "NJ",
  },
  {
    name: "New Mexico",
    abbreviation: "NM",
  },
  {
    name: "New York",
    abbreviation: "NY",
  },
  {
    name: "North Carolina",
    abbreviation: "NC",
  },
  {
    name: "North Dakota",
    abbreviation: "ND",
  },
  {
    name: "Ohio",
    abbreviation: "OH",
  },
  {
    name: "Oklahoma",
    abbreviation: "OK",
  },
  {
    name: "Oregon",
    abbreviation: "OR",
  },
  {
    name: "Pennsylvania",
    abbreviation: "PA",
  },
  {
    name: "Rhode Island",
    abbreviation: "RI",
  },
  {
    name: "South Carolina",
    abbreviation: "SC",
  },
  {
    name: "South Dakota",
    abbreviation: "SD",
  },
  {
    name: "Tennessee",
    abbreviation: "TN",
  },
  {
    name: "Texas",
    abbreviation: "TX",
  },
  {
    name: "Utah",
    abbreviation: "UT",
  },
  {
    name: "Vermont",
    abbreviation: "VT",
  },
  {
    name: "Virgin Islands",
    abbreviation: "VI",
  },
  {
    name: "Virginia",
    abbreviation: "VA",
  },
  {
    name: "Washington",
    abbreviation: "WA",
  },
  {
    name: "West Virginia",
    abbreviation: "WV",
  },
  {
    name: "Wisconsin",
    abbreviation: "WI",
  },
  {
    name: "Wyoming",
    abbreviation: "WY",
  },
];

export const customTheme = createTheme({
  palette: {
    primary: {
      main: "#00B1E1",
      light: "#00B1E1",
      dark: "#00B1E1",
    },
    secondary: {
      main: "#00B1E1",
    },
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        "&$notchedOutline": {
          border: "1px solid #EEEEF2",
        },
        "&$focused $notchedOutline": {
          border: "1px solid #00B1E1",
          borderWidth: "1px",
        },
        "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
          border: "1px solid #7FD8F0",
        },
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: "#00B1E1",
        color: "#FFF",
        "&:hover": {
          backgroundColor: "#00B1E1",
        },
      },
      current: {
        color: "#00B1E1",
      },
    },
    MuiPickersDatePickerRoot: {
      toolbar: {
        backgroundColor: "#00B1E1",
      },
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        color: "#FFF",
      },
      toolbarBtnSelected: {
        color: "#FFF",
      },
    },
    MuiInputLabel: {
      top: "-3px",
      outlined: {
        "&$shrink": {
          transform: "translate(14px, 0px) scale(0.75)",
        },
      },
    },
  },
});

class FormVariablesWidget extends Component {
  state = {
    displayClientList: false,
  };

  getLabel = (variable, key) => {
    return (
      (variable.value.length > 1 && variable.name + " #" + (key + 1)) ||
      variable.name
    );
  };

  render() {
    const {
      variable,
      textVariableChange,
      textNumberVariableChange,
      menuVariableChange,
      dateVariableChange,
      addressVariableChange,
      toggleCheckbox,
      groupsVariableChange,
      addAnotherValue,
      removeAnotherValue,
      autocomplete,
      clients,
      defaultValueMode,
    } = this.props;

    const FromClientsLabel = () => {
      return (
        <div className="imported-from-client-icons-container">
          <div className="imported-from-client-animate">
            <div className="imported-from-client-text">from clients</div>
          </div>
          <div className="imported-from-client-icon" />
        </div>
      );
    };

    const onBlurField = () => {
      this.setState({
        ...this.state,
        displayClientList: false,
      });
    };

    function textVariableRender(value, key2) {
      return (
        <div
          className="multiple-variable-value-container"
          key={"multiple_value_" + key2}
        >
          {variable.isMatched && <FromClientsLabel />}
          <div>
            {this.getLabel(variable, key2) === "Company Name" ? (
              <div className="company-name-field-container">
                <DKFormTextInput
                  className="variable-text"
                  data-testid="input-form-company-name"
                  label={this.getLabel(variable, key2)}
                  type="text"
                  fullWidth={true}
                  onChange={(event, value) => {
                    if (event.target.value.length > 0) {
                      this.setState({
                        ...this.state,
                        displayClientList: true,
                      });
                    } else if (event.target.value.length === 0) {
                      this.setState({
                        ...this.state,
                        displayClientList: false,
                      });
                    }
                    textVariableChange(variable.id, key2, event, value);
                  }}
                  value={value || ""}
                  variant="outlined"
                  onBlur={() => onBlurField()}
                />
                {this.state.displayClientList &&
                  clients &&
                  clients.filter((client) =>
                    client.client_name
                      .toLowerCase()
                      .includes(value.toLowerCase())
                  ).length > 0 && (
                    <div className="dd-client-wrapper">
                      <div className="dd-client-list">
                        <div className="dd-client-list-helper-text-item">
                          We are found some companies data in a clients list
                          which can be applied to this form
                        </div>
                        {clients
                          .filter((client) =>
                            client.client_name
                              .toLowerCase()
                              .includes(value.toLowerCase())
                          )
                          .map((client) => {
                            return (
                              <div
                                key={`client-${client.id}`}
                                className="dd-client-list-item"
                                onMouseDown={(e) => {
                                  autocomplete(client);
                                  textVariableChange(
                                    variable.id,
                                    key2,
                                    e,
                                    client
                                  );
                                }}
                              >
                                {client.client_name}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  )}
              </div>
            ) : (
              <MuiThemeProvider theme={customTheme}>
                <TextField
                  className="variable-text"
                  label={this.getLabel(variable, key2)}
                  type="text"
                  fullWidth={true}
                  onChange={(event) => {
                    textVariableChange(variable.id, key2, event);
                  }}
                  value={value || ""}
                  variant="outlined"
                />
              </MuiThemeProvider>
            )}
          </div>
          {key2 === 0 && variable.is_multiple && (
            <div className="additional-block">
              <div className="add-container">
                <div
                  className="create"
                  onClick={addAnotherValue(variable)}
                  data-tip
                  data-for={"addAnother" + variable.name}
                />
                <ReactTooltip
                  id={"addAnother" + variable.name}
                  place="top"
                  className="tooltip-cls"
                >
                  Add Another {variable.name}
                </ReactTooltip>
              </div>
            </div>
          )}
          {key2 !== 0 && (
            <div className="minus-container">
              <div
                className="minus"
                onClick={removeAnotherValue(variable, key2)}
              />
            </div>
          )}
        </div>
      );
    }

    function numberVariableRender(value, key2) {
      let numberValue;
      return (
        <div
          className="multiple-variable-value-container"
          key={"multiple_value_" + key2}
        >
          <MuiThemeProvider theme={customTheme}>
            {variable.isMatched && <FromClientsLabel />}
            <NumberFormat
              customInput={NumberFormatInput}
              className="variable-text"
              label={this.getLabel(variable, key2)}
              value={value}
              fullWidth={true}
              thousandSeparator={true}
              onValueChange={(values) => {
                numberValue = values.value;
              }}
              onChange={() => {
                textNumberVariableChange(variable.id, numberValue, key2);
              }}
              variant="outlined"
              variable={variable}
            />
          </MuiThemeProvider>
          {key2 === 0 && variable.is_multiple && (
            <div className="additional-block">
              <div className="add-container">
                <div
                  className="create"
                  onClick={addAnotherValue(variable)}
                  data-tip
                  data-for={"addAnother" + variable.name}
                />
                <ReactTooltip
                  id={"addAnother" + variable.name}
                  place="top"
                  className="tooltip-cls"
                >
                  Add Another {variable.name}
                </ReactTooltip>
              </div>
            </div>
          )}
          {key2 !== 0 && (
            <div className="minus-container">
              <div
                className="minus"
                onClick={removeAnotherValue(variable, key2)}
              />
            </div>
          )}
        </div>
      );
    }

    function currencyVariableRender(value, key2) {
      let numberValue;
      return (
        <div
          className="multiple-variable-value-container"
          key={"multiple_value_" + key2}
        >
          <MuiThemeProvider theme={customTheme}>
            {variable.isMatched && <FromClientsLabel />}
            <NumberFormat
              customInput={NumberFormatInput}
              className="variable-text"
              label={this.getLabel(variable, key2)}
              value={value}
              fullWidth={true}
              thousandSeparator={true}
              prefix={"$"}
              onValueChange={(values) => {
                numberValue = values.value;
              }}
              onChange={() => {
                textNumberVariableChange(variable.id, numberValue, key2);
              }}
              variant="outlined"
              variable={variable}
            />
          </MuiThemeProvider>
          {key2 === 0 && variable.is_multiple && (
            <div className="additional-block">
              <div className="add-container">
                <div
                  className="create"
                  onClick={addAnotherValue(variable)}
                  data-tip
                  data-for={"addAnother" + variable.name}
                />
                <ReactTooltip
                  id={"addAnother" + variable.name}
                  place="top"
                  className="tooltip-cls"
                >
                  Add Another {variable.name}
                </ReactTooltip>
              </div>
            </div>
          )}
          {key2 !== 0 && (
            <div className="minus-container">
              <div
                className="minus"
                onClick={removeAnotherValue(variable, key2)}
              />
            </div>
          )}
        </div>
      );
    }

    function percentageVariableRender(value, key2) {
      let numberValue;
      return (
        <div
          className="multiple-variable-value-container"
          key={"multiple_value_" + key2}
        >
          <MuiThemeProvider theme={customTheme}>
            {variable.isMatched && <FromClientsLabel />}
            <NumberFormat
              customInput={NumberFormatInput}
              className="variable-text"
              label={this.getLabel(variable, key2)}
              fullWidth={true}
              value={value}
              suffix={"%"}
              onValueChange={(values) => {
                numberValue = values.value;
              }}
              onChange={() => {
                textNumberVariableChange(variable.id, numberValue, key2);
              }}
              variant="outlined"
              variable={variable}
            />
          </MuiThemeProvider>
          {key2 === 0 && variable.is_multiple && (
            <div className="additional-block">
              <div className="add-container">
                <div
                  className="create"
                  onClick={addAnotherValue(variable)}
                  data-tip
                  data-for={"addAnother" + variable.name}
                />
                <ReactTooltip
                  id={"addAnother" + variable.name}
                  place="top"
                  className="tooltip-cls"
                >
                  Add Another {variable.name}
                </ReactTooltip>
              </div>
            </div>
          )}
          {key2 !== 0 && (
            <div className="minus-container">
              <div
                className="minus"
                onClick={removeAnotherValue(variable, key2)}
              />
            </div>
          )}
        </div>
      );
    }

    function dateVariableRender(value, key2) {
      return (
        <div
          className="multiple-variable-value-container"
          key={"multiple_value_" + key2}
        >
          <MuiThemeProvider theme={customTheme}>
            {variable.isMatched && <FromClientsLabel />}
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div className="date-picker-container">
                {/* //TODO: The KeyboardDatePicker is deprecated and should be replaced https://mui.com/material-ui/guides/pickers-migration/ */}
                <KeyboardDatePicker
                  className="variable-text"
                  label={this.getLabel(variable, key2)}
                  value={
                    (value && toISOString(new Date(value))) ||
                    toISOString(new Date())
                  }
                  onChange={dateVariableChange(variable.id, key2)}
                  views={["date"]}
                  fullWidth={true}
                  format="MMMM d, yyyy"
                  keyboardIcon={<img src={calendarIcon} alt={"calendarIcon"} />}
                  inputVariant="outlined"
                  InputProps={{ readOnly: true }}
                  onClick={() => {
                    this.setState({
                      [this.getLabel(variable, key2)]: true,
                    });
                  }}
                  onClose={() => {
                    this.setState({
                      [this.getLabel(variable, key2)]: false,
                    });
                  }}
                  open={this.state[this.getLabel(variable, key2)] || false}
                  autoOk={true}
                />
              </div>
            </MuiPickersUtilsProvider>
          </MuiThemeProvider>
          {key2 === 0 && variable.is_multiple && (
            <div className="additional-block">
              <div className="add-container">
                <div
                  className="create"
                  onClick={addAnotherValue(variable)}
                  data-tip
                  data-for={"addAnother" + variable.name}
                />
                <ReactTooltip
                  id={"addAnother" + variable.name}
                  place="top"
                  className="tooltip-cls"
                >
                  Add Another {variable.name}
                </ReactTooltip>
              </div>
            </div>
          )}
          {key2 !== 0 && (
            <div className="minus-container">
              <div
                className="minus"
                onClick={removeAnotherValue(variable, key2)}
              />
            </div>
          )}
        </div>
      );
    }

    function addressVariableRender(value, key2) {
      let label = variable.name;
      if (key2 > 0) {
        label += " #" + (key2 + 1);
      }
      return (
        <div
          className="multiple-variable-value-container address-variable-container"
          key={"multiple_value_" + key2}
        >
          <MuiThemeProvider theme={customTheme}>
            {variable.isMatched && <FromClientsLabel />}
            <TextField
              className="variable-text"
              label="Street"
              type="text"
              fullWidth={true}
              onChange={addressVariableChange(variable.id, key2, "line")}
              value={(value && value.line) || ""}
              variant="outlined"
            />
          </MuiThemeProvider>
          <div className="template-variable-address-container">
            <MuiThemeProvider theme={customTheme}>
              <TextField
                className="variable-text city"
                label="City"
                type="text"
                onChange={addressVariableChange(variable.id, key2, "city")}
                value={(value && value.city) || ""}
                variant="outlined"
              />
            </MuiThemeProvider>
            <FormControl className="variable-text state" variant="outlined">
              <MuiThemeProvider theme={customTheme}>
                <Autocomplete
                  id={`autocomplete-${variable.name}`}
                  options={states}
                  getOptionLabel={(state) => state.name}
                  classes={{
                    inputRoot: "autocomplete-input-root",
                    input: "autocomplete-input",
                  }}
                  ListboxProps={{
                    style: {
                      fontFamily: "Open Sans",
                      fontSize: "14px",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="State" variant="outlined" />
                  )}
                  inputValue={(value && value.state) || ""}
                  onChange={addressVariableChange(variable.id, key2, "state")}
                />
              </MuiThemeProvider>
            </FormControl>
            <MuiThemeProvider theme={customTheme}>
              <TextField
                className="variable-text zip"
                label="ZIP Code"
                type="text"
                onChange={addressVariableChange(variable.id, key2, "zip")}
                value={(value && value.zip) || ""}
                variant="outlined"
              />
            </MuiThemeProvider>
          </div>
          <div className="bottom-border" />
          <div className="label-block">{label}</div>
          {key2 === 0 && variable.is_multiple && (
            <div className="additional-block">
              <div className="add-container">
                <span className="add-another-text">
                  Add Another {variable.name}
                </span>
                <div className="create" onClick={addAnotherValue(variable)} />
              </div>
            </div>
          )}
          {key2 !== 0 && (
            <div className="minus-container">
              <div
                className="minus"
                onClick={removeAnotherValue(variable, key2)}
              />
            </div>
          )}
        </div>
      );
    }

    function groupVariableRender(value, key2) {
      let label = variable.name;
      if (key2 > 0) {
        label += " #" + (key2 + 1);
      }
      return (
        <div className="group-variable" key={"multiple_value_" + key2}>
          {variable.isMatched && <FromClientsLabel />}
          <div className="label-block">{label}</div>
          <div className="bottom-border" />
          {key2 === 0 && variable.is_multiple && (
            <div className="additional-block">
              <div className="label-additional-block">
                Add Another {variable.name}
              </div>
              <div className="add-container">
                <div
                  className="create"
                  onClick={addAnotherValue(variable)}
                  data-tip
                  data-for={"addAnother" + variable.name}
                />
                <ReactTooltip
                  id={"addAnother" + variable.name}
                  place="top"
                  className="tooltip-cls"
                >
                  Add Another {variable.name}
                </ReactTooltip>
              </div>
            </div>
          )}
          {key2 !== 0 && (
            <div className="minus-container">
              <div
                className="minus"
                onClick={removeAnotherValue(variable, key2)}
              />
            </div>
          )}
          <React.Fragment>
            {variable.sub_variables &&
              variable.sub_variables.map((v, key3) => {
                if (v.type === "menu") {
                  v.items = JSON.parse(v.info).items;
                }
                return (
                  <div
                    className="group-variable-item"
                    key={"multiple_sub_variable_" + key3}
                  >
                    {v &&
                      v.type === "text" &&
                      ["text", null].indexOf(v.data_type) > -1 && (
                        <MuiThemeProvider theme={customTheme}>
                          <TextField
                            className="variable-text"
                            label={v.name}
                            type="text"
                            fullWidth={true}
                            onChange={(event) => {
                              groupsVariableChange(
                                variable.id,
                                v,
                                key2,
                                undefined,
                                event,
                                undefined
                              );
                            }}
                            value={value[v.id] || ""}
                            variant="outlined"
                          />
                        </MuiThemeProvider>
                      )}
                    {v && v.type === "text" && v.data_type === "number" && (
                      <MuiThemeProvider theme={customTheme}>
                        <NumberFormat
                          customInput={NumberFormatInput}
                          className="variable-text"
                          label={v.name}
                          value={value[v.id]}
                          thousandSeparator={true}
                          onValueChange={(values) => {
                            groupsVariableChange(
                              variable.id,
                              v,
                              key2,
                              undefined,
                              undefined,
                              values.value
                            );
                          }}
                          variant="outlined"
                          variable={v}
                        />
                      </MuiThemeProvider>
                    )}
                    {v && v.type === "text" && v.data_type === "currency" && (
                      <MuiThemeProvider theme={customTheme}>
                        <NumberFormat
                          customInput={NumberFormatInput}
                          className="variable-text"
                          label={v.name}
                          value={value[v.id]}
                          thousandSeparator={true}
                          prefix={"$"}
                          onValueChange={(values) => {
                            groupsVariableChange(
                              variable.id,
                              v,
                              key2,
                              undefined,
                              undefined,
                              values.value
                            );
                          }}
                          variant="outlined"
                          variable={v}
                        />
                      </MuiThemeProvider>
                    )}
                    {v && v.type === "text" && v.data_type === "percentage" && (
                      <MuiThemeProvider theme={customTheme}>
                        <NumberFormat
                          customInput={NumberFormatInput}
                          className="variable-text"
                          label={v.name}
                          value={value[v.id]}
                          suffix={"%"}
                          onValueChange={(values) => {
                            groupsVariableChange(
                              variable.id,
                              v,
                              key2,
                              undefined,
                              undefined,
                              values.value
                            );
                          }}
                          variant="outlined"
                          variable={v}
                        />
                      </MuiThemeProvider>
                    )}
                    {v && v.type === "date" && (
                      <MuiThemeProvider theme={customTheme}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <div className="date-picker-container">
                            {/* //TODO: The KeyboardDatePicker is deprecated and should be replaced https://mui.com/material-ui/guides/pickers-migration/ */}
                            <KeyboardDatePicker
                              className="variable-text"
                              label={v.name}
                              value={
                                value[v.id] &&
                                toISOString(new Date(value[v.id]))
                              }
                              onChange={(date) => {
                                groupsVariableChange(
                                  variable.id,
                                  v,
                                  key2,
                                  undefined,
                                  undefined,
                                  date
                                );
                              }}
                              views={["date"]}
                              format="MMMM d, yyyy"
                              inputVariant="outlined"
                              InputProps={{ readOnly: true }}
                              keyboardIcon={
                                <img src={calendarIcon} alt={"calendarIcon"} />
                              }
                              onClick={() => {
                                this.setState({
                                  [v.name]: true,
                                });
                              }}
                              onClose={() => {
                                this.setState({
                                  [v.name]: false,
                                });
                              }}
                              open={this.state[v.name] || false}
                              autoOk={true}
                            />
                          </div>
                        </MuiPickersUtilsProvider>
                      </MuiThemeProvider>
                    )}
                    {v && v.type === "address" && (
                      <div className="multiple-variable-value-container address-variable-container">
                        <MuiThemeProvider theme={customTheme}>
                          <TextField
                            className="variable-text"
                            label="Street"
                            type="text"
                            fullWidth={true}
                            onChange={(e) => {
                              groupsVariableChange(
                                variable.id,
                                v,
                                key2,
                                "line",
                                e
                              );
                            }}
                            value={(value[v.id] && value[v.id].line) || ""}
                            variant="outlined"
                          />
                        </MuiThemeProvider>
                        <div className="template-variable-address-container">
                          <MuiThemeProvider theme={customTheme}>
                            <TextField
                              className="variable-text city"
                              label="City"
                              type="text"
                              onChange={(e) => {
                                groupsVariableChange(
                                  variable.id,
                                  v,
                                  key2,
                                  "city",
                                  e
                                );
                              }}
                              value={(value[v.id] && value[v.id].city) || ""}
                              variant="outlined"
                            />
                          </MuiThemeProvider>
                          <FormControl
                            className="variable-text state"
                            variant={"outlined"}
                          >
                            <MuiThemeProvider theme={customTheme}>
                              <Autocomplete
                                id={`autocomplete-group-address-${key2}`}
                                options={states}
                                getOptionLabel={(state) => state.name}
                                classes={{
                                  inputRoot: "autocomplete-input-root",
                                  input: "autocomplete-input",
                                }}
                                ListboxProps={{
                                  style: {
                                    fontFamily: "Open Sans",
                                    fontSize: "14px",
                                  },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="State"
                                    variant="outlined"
                                  />
                                )}
                                onChange={(e, value) => {
                                  groupsVariableChange(
                                    variable.id,
                                    v,
                                    key2,
                                    "state",
                                    e,
                                    value
                                  );
                                }}
                              />
                            </MuiThemeProvider>
                          </FormControl>
                          <MuiThemeProvider theme={customTheme}>
                            <TextField
                              className="variable-text zip"
                              label="ZIP Code"
                              type="text"
                              onChange={(e) => {
                                groupsVariableChange(
                                  variable.id,
                                  v,
                                  key2,
                                  "zip",
                                  e
                                );
                              }}
                              value={(value[v.id] && value[v.id].zip) || ""}
                              variant="outlined"
                            />
                          </MuiThemeProvider>
                        </div>
                        <div className="label-block">Address</div>
                        <div className="bottom-border" />
                      </div>
                    )}
                    {v && v.type === "menu" && (
                      <div className="variable-container menu-variable-container">
                        <div className="menu-variable-title">{v.name}</div>
                        <MuiThemeProvider theme={customTheme}>
                          <RadioGroup
                            name={"menu_" + key2}
                            value={value[v.id] || ""}
                            onChange={(e) => {
                              groupsVariableChange(
                                variable.id,
                                v,
                                key2,
                                undefined,
                                e
                              );
                            }}
                          >
                            {v &&
                              v.items &&
                              v.items.map((item, key) => {
                                return (
                                  <FormControlLabel
                                    className="menu-variable-label"
                                    key={"item_" + key}
                                    value={item}
                                    control={
                                      <Radio
                                        icon={
                                          <img
                                            src={unCheckedRadioIcon}
                                            alt={"unCheckedRadioIcon"}
                                          />
                                        }
                                        checkedIcon={
                                          <img
                                            src={checkedBlueIcon}
                                            alt={"checkedRadioIcon"}
                                          />
                                        }
                                        color="primary"
                                        checked={item === value[v.id]}
                                      />
                                    }
                                    label={item}
                                  />
                                );
                              })}
                          </RadioGroup>
                        </MuiThemeProvider>
                      </div>
                    )}
                    {v && v.type === "checkbox" && (
                      <div className="checkbox-variable-container">
                        <div className="checkbox-title">{v.name}</div>
                        <div className="checkbox-buttons-container">
                          <div
                            className={
                              value[v.id] === "checked"
                                ? "checkbox-button checkbox-accept active"
                                : "checkbox-button"
                            }
                            onClick={() => {
                              groupsVariableChange(
                                variable.id,
                                v,
                                key2,
                                "checked"
                              );
                            }}
                          >
                            <div className={"checkbox-accept-icon"} />
                            YES
                          </div>
                          <div
                            className={
                              value[v.id] === "unchecked"
                                ? "checkbox-button checkbox-decline active"
                                : "checkbox-button"
                            }
                            onClick={() => {
                              groupsVariableChange(
                                variable.id,
                                v,
                                key2,
                                "unchecked"
                              );
                            }}
                          >
                            <div className={"checkbox-decline-icon"} />
                            NO
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
          </React.Fragment>
        </div>
      );
    }

    return (
      <div className="shift">
        {variable &&
          variable.type === "text" &&
          ["text", null].indexOf(variable.data_type) > -1 && (
            <div className="variable-container">
              {defaultValueMode
                ? variable.default_value &&
                  !!variable.default_value.length &&
                  variable.default_value.map(textVariableRender, this)
                : variable.value &&
                  !!variable.value.length &&
                  variable.value.map(textVariableRender, this)}
            </div>
          )}

        {variable &&
          variable.type === "text" &&
          variable.data_type === "number" && (
            <div className="variable-container">
              {defaultValueMode
                ? variable.default_value &&
                  !!variable.default_value.length &&
                  variable.default_value.map(numberVariableRender, this)
                : variable.value &&
                  !!variable.value.length &&
                  variable.value.map(numberVariableRender, this)}
            </div>
          )}

        {variable &&
          variable.type === "text" &&
          variable.data_type === "currency" && (
            <div className="variable-container">
              {defaultValueMode
                ? variable.default_value &&
                  !!variable.default_value.length &&
                  variable.default_value.map(currencyVariableRender, this)
                : variable.value &&
                  !!variable.value.length &&
                  variable.value.map(currencyVariableRender, this)}
            </div>
          )}

        {variable &&
          variable.type === "text" &&
          variable.data_type === "percentage" && (
            <div className="variable-container">
              {defaultValueMode
                ? variable.default_value &&
                  !!variable.default_value.length &&
                  variable.default_value.map(percentageVariableRender, this)
                : variable.value &&
                  !!variable.value.length &&
                  variable.value.map(percentageVariableRender, this)}
            </div>
          )}

        {variable && variable.type === "menu" && (
          <div className="variable-container menu-variable-container">
            <div className="menu-variable-title">{variable.name}</div>
            <MuiThemeProvider theme={customTheme}>
              {variable.isMatched && <FromClientsLabel />}
              <RadioGroup
                name={(variable && variable.name) || "menu"}
                value={
                  (defaultValueMode
                    ? variable.default_value[0]
                    : variable.value[0]) || ""
                }
                onChange={menuVariableChange(variable.id, 0)}
              >
                {variable &&
                  variable.items &&
                  variable.items.items &&
                  variable.items.items.map((item, key) => {
                    return (
                      <FormControlLabel
                        key={"item_" + key}
                        value={item}
                        className="menu-variable-label"
                        control={
                          <Radio
                            icon={
                              <img
                                src={unCheckedRadioIcon}
                                alt={"unCheckedRadioIcon"}
                              />
                            }
                            checkedIcon={
                              <img
                                src={checkedBlueIcon}
                                alt={"checkedRadioIcon"}
                              />
                            }
                            color="primary"
                            checked={
                              item ===
                              (defaultValueMode
                                ? variable.default_value[0]
                                : variable.value[0])
                            }
                          />
                        }
                        label={item}
                      />
                    );
                  })}
              </RadioGroup>
            </MuiThemeProvider>
          </div>
        )}

        {variable && variable.type === "date" && (
          <div className="variable-container">
            {defaultValueMode
              ? variable.default_value &&
                !!variable.default_value.length &&
                variable.default_value.map(dateVariableRender, this)
              : variable.value &&
                !!variable.value.length &&
                variable.value.map(dateVariableRender, this)}
          </div>
        )}

        {variable && variable.type === "address" && (
          <div className="variable-container">
            {defaultValueMode
              ? variable.default_value &&
                !!variable.default_value.length &&
                variable.default_value.map(addressVariableRender, this)
              : variable.value &&
                !!variable.value.length &&
                variable.value.map(addressVariableRender, this)}
          </div>
        )}

        {variable && variable.type === "checkbox" && (
          <div className="variable-container checkbox-variable-container">
            <div className="checkbox-title">{variable.name}</div>
            <div className="checkbox-buttons-container">
              {variable.isMatched && <FromClientsLabel />}
              <div
                className={
                  (defaultValueMode
                    ? variable.default_value[0]
                    : variable.value[0]) === "checked"
                    ? "checkbox-button checkbox-accept active"
                    : "checkbox-button"
                }
                onClick={() => toggleCheckbox(variable.id, "checked", 0)}
              >
                <div className={"checkbox-accept-icon"} />
                YES
              </div>
              <div
                className={
                  (defaultValueMode
                    ? variable.default_value[0]
                    : variable.value[0]) === "unchecked"
                    ? "checkbox-button checkbox-decline active"
                    : "checkbox-button"
                }
                onClick={() => toggleCheckbox(variable.id, "unchecked", 0)}
              >
                <div className={"checkbox-decline-icon"} />
                NO
              </div>
            </div>
          </div>
        )}

        {variable && variable.type === "group" && (
          <div className="variable-container group-variable-container">
            {defaultValueMode
              ? variable.default_value &&
                !!variable.default_value.length &&
                variable.default_value.map(groupVariableRender, this)
              : variable.value &&
                !!variable.value.length &&
                variable.value.map(groupVariableRender, this)}
          </div>
        )}
      </div>
    );
  }
}

export default FormVariablesWidget;
